module.exports = __webpack_public_path__ + "img/03539c0.jpg";